import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../components/Loading/Lazy';

const NotifLoadable = loadable(() => import(/* webpackChunkName: "notif-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default NotifLoadable;
